export const en = {
    'age-required': 'No age given',
    'all-conditions-done': 'All conditions are met',
    'all-devices-rate-value': 'You cannot set a {value}% adjustment for all devices',
    'all-inventories-rate-value': 'You cannot set a {value}% adjustment for all types of inventory',
    cloudiness: 'Cloud cover',
    'cloudiness-clear': 'Clear',
    'cloudiness-hint': 'Cloud cover - {value} ',
    'cloudiness-medium': 'Cloudy',
    'cloudiness-overcast': 'Overcast',
    'cloudiness-partly': 'Partly cloudy',
    'cloudiness-significant': 'Very cloudy',
    'equal-items': 'Conditions No. {numbers} overlap. Delete one or change their settings. ',
    'gender-required': 'No gender given',
    'incorrect-max-temperature': "The maximum temperature can't be below the minimum temperature",
    'intersection-items-warning': {
        one: 'Conflicts with condition {list}',
        some: 'Conflicts with conditions {list}',
        many: 'Conflicts with conditions {list}',
        none: 'Conflicts with conditions {list}'
    },
    'max-rate-value': "Don't increase rates above {value}%",
    'min-rate-value': "Don't lower rates below {value}%",
    'one-condition-done': 'At least one fulfilled',
    'positive-value': 'Rate should be a positive whole number',
    rainfall: 'Precipitation',
    'rainfall-average': 'Average',
    'rainfall-heavy': 'Heavy',
    'rainfall-hint': 'Precipitation - {value}',
    'rainfall-light': 'Light',
    'rainfall-none': 'None',
    'rainfall-rain-snow': 'Heavy rain/snow',
    'single-mass-rate-empty': 'A single rate is not set',
    temperature: 'Temperature',
    'temperature-hint': 'Temperature is between {minTemperature} and {maxTemperature} °C',
    'traffic-jam-free': 'No traffic jams',
    'traffic-jam-hard': 'Traffic',
    'traffic-jam-light': 'Heavy traffic',
    'traffic-jam-very-hard': 'Severe traffic jams',
    'value-required': 'Bid not set'
};
